import { RootState } from 'editor/src/store/index';

import { isEmbedded } from '../../watchers/useDisplayMode';

import isAddElementsAllowed from './isAddElementsAllowed';

/**
 * Linking text frames is opt-in per host (`enableTextFlow`). In the embedded (buyer)
 * editor it additionally follows the template's "Add layers" switch, like fixed frames and text
 * styles. Linked frames already in a design always flow; this gates linking, and unlinking for a buyer.
 */
const isTextFlowAllowed = (state: RootState) =>
  !!state.hostSettings.enableTextFlow && (!isEmbedded || isAddElementsAllowed(state));

export default isTextFlowAllowed;
